export const DARK_PRODUCTS_STACK_ID = 'NDX-LOD-V2';
export const LIGHT_PRODUCTS_STACK_ID = 'NDX-DOL-V2';
